import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { organization } from '../content/organization';

export function OrganizationMetadata() {
    const { pathname } = useLocation();
    useEffect(() => {
        if ((pathname.replace(/\/+$/, '') || '/') !== '/') return;
        const script = document.createElement('script');
        script.id = 'organization-structured-data';
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(organization);
        document.head.appendChild(script);
        return () => { script.remove(); };
    }, [pathname]);
    return null;
}
